<template>
  <main class="l-main p-competitive-site-keyword">
    <TitleMain
      icon="competitiveKeyword"
      faq="/sections/360001240035"
      howTo="/sections/4404626248719"
    >
      <span class="title">競合キーワード分析</span>
      <span class="description">
        競合のドメインが取得している<br />キーワードの一覧を表示します。
      </span>
    </TitleMain>
    <div class="l-container">
      <div class="l-toolBlock">
        <ButtonToProjects />
        <Button
          v-if="$route.name !== 'competitiveSiteKeyword'"
          :to="{
            name: 'competitiveSiteKeyword'
          }"
          variant="light"
          icon="pageback"
          radius
        >
          競合キーワード分析一覧に戻る
        </Button>
        <Breadcrumb />
      </div>
      <router-view :date="date" :id="id" :project="project" />
    </div>
    <portal-target class="c-form-task__wrapper" name="form-add-tasks" />
  </main>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import Button from '@/components/Button';
import ButtonToProjects from '@/components/ButtonToProjects';
import TitleMain from '@/components/TitleMain';

export default {
  props: ['date', 'id', 'project'],
  components: {
    Breadcrumb,
    Button,
    ButtonToProjects,
    TitleMain
  }
};
</script>
